import { useState, useEffect } from 'react';
import { fetchAllOrdersAsync } from '../fetch/orderFetch';
import { OrderClazz, OrderSearchStatus, Region } from '../types/orderTypes';
import { Dayjs } from 'dayjs';
import { ReqEnum } from '../const/requestStatus';

export function useFetchOrders(
  statusReq: OrderSearchStatus,
  startDate: Dayjs,
  endDate: Dayjs,
  region: Region = undefined,
  includeBundleIds = false
): [OrderClazz[], ReqEnum] {
  const [fetchStatus, setFetchStatus] = useState<ReqEnum>(ReqEnum.INIT);
  const [orders, setOrders] = useState<OrderClazz[]>([]);

  useEffect(() => {
    setFetchStatus(ReqEnum.PENDING);
    const fetchOrders = async () => {
      const orders = await fetchAllOrdersAsync(
        startDate,
        endDate,
        statusReq,
        region,
        null,
        includeBundleIds
      );
      setOrders(orders);
      setFetchStatus(ReqEnum.SUCCESS);
    };
    fetchOrders();
  }, [statusReq, startDate, endDate, region, includeBundleIds]);

  return [orders, fetchStatus];
}
